import { lazy } from 'react';
import MainLayout from '../components/Layout/MainLayout';

const Login = lazy(() => import('../pages/Login'));
const Home = lazy(() => import('../pages/Home'));
const DoctorManagement = lazy(() => import('../pages/DoctorManagement'));
const DoctorDetail = lazy(() => import('../pages/DoctorDetail'));
const WechatLoginSuccess = lazy(() => import('../pages/WechatLoginSuccess'));
const WechatLoginSuccess2 = lazy(() => import('../pages/WechatLoginSuccess2'));
const DeviceManagement = lazy(() => import('../pages/DeviceManagement'));
const H5JumpMiniprogam = lazy(() => import('../pages/H5JumpMiniprogam'));

// 知识库相关页面
const KnowledgeHome = lazy(() => import('../pages/KnowledgeHome'));
const DocumentDetail = lazy(() => import('../pages/DocumentDetail'));
const CategoryManagement = lazy(() => import('../pages/CategoryManagement'));
const TagManagement = lazy(() => import('../pages/TagManagement'));
const DocumentManagement = lazy(() => import('../pages/DocumentManagement'));
const DocumentEditor = lazy(() => import('../pages/DocumentEditor'));

export const routes = [
    {
        path: '/miniprogramaism',
        element: <H5JumpMiniprogam />,
        requiresAuth: false,
        title: 'h5跳转小程序',
    },
    {
        path: '/login',
        element: <Login />,
        requiresAuth: false,
        title: '登录',
    },
    {
        path: '/wechat-login-success',
        element: <WechatLoginSuccess />,
        requiresAuth: false,
        title: '微信登录成功',
    },
    {
        path: '/mirror-login',
        element: <WechatLoginSuccess2 />,
        requiresAuth: false,
        title: '微信登录成功',
    },
    // 知识库游客访问路由（无需登录）
    {
        path: '/knowledge',
        element: <KnowledgeHome />,
        requiresAuth: false,
        title: '知识库',
    },
    {
        path: '/knowledge/documents/:documentId',
        element: <DocumentDetail />,
        requiresAuth: false,
        title: '文档详情',
    },
    // 管理后台路由（需要登录）
    {
        path: '/',
        element: <MainLayout />,
        requiresAuth: true,
        title: '主页面',
        children: [
            {
                index: true,
                element: <Home />,
                requiresAuth: true,
                title: '首页',
            },
            {
                path: 'doctors',
                element: <DoctorManagement />,
                requiresAuth: true,
                title: '医生管理',
            },
            {
                path: 'doctors/:id',
                element: <DoctorDetail />,
                requiresAuth: true,
                title: '医生详情',
            },
            {
                path: 'store',
                element: <DeviceManagement />,
                requiresAuth: true,
                title: '设备管理',
            },
            // 知识库管理路由
            {
                path: '/categories',
                element: <CategoryManagement />,
                requiresAuth: true,
                title: '分类管理',
            },
            {
                path: '/tags',
                element: <TagManagement />,
                requiresAuth: true,
                title: '标签管理',
            },
            {
                path: 'documents',
                element: <DocumentManagement />,
                requiresAuth: true,
                title: '文档管理',
            },
            {
                path: 'documents/create',
                element: <DocumentEditor />,
                requiresAuth: true,
                title: '创建文档',
            },
            {
                path: 'documents/edit/:documentId',
                element: <DocumentEditor />,
                requiresAuth: true,
                title: '编辑文档',
            },
        ],
    },
];
